import { render, staticRenderFns } from "./BrandDropdown.vue?vue&type=template&id=0d10f498"
import script from "./BrandDropdown.vue?vue&type=script&lang=js"
export * from "./BrandDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports